<template>
  <div>
    <b-table
      id="materials-table"
      :fields="fields"
      :items="materialAndInstrumentApplicationsForEdit"
      responsive
      :tbody-tr-class="['tableRowClass']"
      class="mt-2"
      show-empty
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>
      
      <template #cell(actions)="data">
        <div>
          <b-button
            v-if="!viewMode"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            class="mt-50 mb-50"
            variant="danger"
            @click="deleteApp(data)"
          >
            <feather-icon
              icon="TrashIcon"
              size="16"
            />
          </b-button>
        </div>
      </template>


      <template #cell(author)="data">
        {{data.item.author && data.item.author.first_name ? data.item.author.first_name : ''}}
         {{data.item.author && data.item.author.last_name ? data.item.author.last_name : ''}}
      </template>

      <template #cell(product)="data">
        <div v-if="data.item && data.item.goods">
          <b-badge
            v-for="(item, index) in data.item.goods" :key="index"
            variant="success"
            class="ml-1"
          >
            {{ (item.good && item.good.value) ? item.good.value : '' }} - {{ $_formatPriceMixin(item.start_count ? item.start_count : 0) }} {{(item.good && item.good.unity) ? (item.good.unity) : ''}}
          </b-badge>
        </div>

        <div>
          <b-badge
            v-for="(item, index) in data.item.instruments" :key="index"
            variant="success"
            class="ml-1"
          >
            {{ item.instrument.title }} - {{ $_formatPriceMixin(item.start_count) }}  {{(item.instrument && item.instrument.unity) ? (item.instrument.unity) : ''}} 
          </b-badge>
        </div>
      </template>


      <template #cell(created_date)="data">
        {{ formatDate(data.item.created_date) }}
      </template>

    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { BTable, BButton, BBadge } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import areYouSure from '@/mixins/areYouSure'
import moment from 'moment'
import priceFormatMixin from '@/mixins/priceFormatMixin';

export default {
  components: {
    BTable,
    BButton,
    BBadge
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure, priceFormatMixin],
  data() {
    return {
      fields: [
        {
          label: 'author',
          key: 'author',
        },
        {
          label: 'reference.name',
          key: 'product',
        },
        {
          label: 'destination_warehouse',
          key: 'storage.title',
        },
        {
          label: 'general.created_at',
          key: 'created_date',
        },
        {
          label: 'actions',
          key: 'actions',
        },
      ],
    }
  },
  computed: {
    ...mapState('agrements', ['materialAndInstrumentApplicationsForEdit', 'viewMode']),


    materialAndInstrumentApplicationsForEdit: {
      get: function () {
        return this.$store.state.agrements.materialAndInstrumentApplicationsForEdit;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS_FOR_EDIT', newValue)
      }
    },
    materialItemsForEdit: {
      get: function () {
        return this.$store.state.agrements.materialItemsForEdit;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_MATERIAL_ITEMS_FOR_EDIT', newValue)
      }
    },
    instrumentItemsForEdit: {
      get: function () {
        return this.$store.state.agrements.instrumentItemsForEdit;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_INSTRUMENT_ITEMS_FOR_EDIT', newValue)
      }
    },
    refreshAgreement: {
      get: function () {
        return this.$store.state.agrements.refreshAgreement;
      },
      set: function (newValue) {
        this.$store.commit('agrements/SET_REFRESH_AGREEMENT', newValue)
      }
    },

  },
  watch: {
  },
  methods: {
    ...mapActions('agrements', [
      'DELETE_CONTRACT_GOODS',
      'DELETE_CONTRACT_INSTRUMENTS',
      'DELETE_REQUIREMENT_GOODS',
      'DELETE_REQUIREMENT_INSTRUMENTS'
    ]),

    async deleteApp(data) {
      await this.$_showAreYouSureModal().then( async val => {
        if(val){

            if(data.item.hasOwnProperty('checked')){
              this.materialAndInstrumentApplicationsForEdit.splice(data.index, 1);
              this.$store.commit('agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS_FOR_EDIT', this.materialAndInstrumentApplicationsForEdit)
            }else{
              await this.DELETE_REQUIREMENT_GOODS({contract_id: this.$route.params.id, requirement_good_id: data.item.id})
              .then(() => {
                this.materialAndInstrumentApplicationsForEdit.splice(data.index, 1);
                this.$store.commit('agrements/SET_MATERIAL_AND_INSTRUMENT_ITEMS_FOR_EDIT', this.materialAndInstrumentApplicationsForEdit)
                // this.materialItemsForEdit.forEach(async (elem) => {
                //   await this.DELETE_CONTRACT_GOODS({id: elem.id})
                // })
                // this.instrumentItemsForEdit.forEach(async (elem) => {
                //   await this.DELETE_CONTRACT_INSTRUMENTS({id: elem.id})
                // })
                // this.refreshAgreement = true
                this.$_okToast()
              })
              .catch(err => {
                this.$_errToast(err)
              })
            }





        }
      })
    },

    formatDate(value){
      return moment(value).format("DD.MM.YYYY")
    }
  },
}
</script>

<style lang="scss">
#materials-table {
  border: 1px solid #f3f2f7;

  th {
    text-align: center;
  }

  .tableRowClass {
    &:nth-child(2n) {
      background: rgba($color: #f3f2f7, $alpha: 0.7);
    }

    td {
      padding: 10px 15px;
      text-align: center;
    }
  }
}
</style>
